export enum ConfigActionType {
    GET_FRONT_CONFIGURATION = 'GET_FRONT_CONFIGURATION',
}
